/* Share rich micropost nodes across desktop/mobile slots, preserving media state
   and avoiding duplicate Ghost card IDs when the same post is in both feeds. */
(function () {
    const desktop = document.querySelector(".alx-home-desktop");
    const mixed = document.querySelector(".alx-home-mixed-feed");
    if (!desktop || !mixed) return;

    const posts = new Map();
    const parking = document.createElement("div");
    parking.hidden = true;
    mixed.after(parking);

    [desktop, mixed].forEach((feed, index) => {
        feed.querySelectorAll(".alx-micro-card").forEach((card) => {
            const id = card.getAttribute("data-alx-micro-id");
            if (!id) return;
            const slot = document.createElement("template");
            card.before(slot);
            if (!posts.has(id)) posts.set(id, {card, slots: []});
            const post = posts.get(id);
            post.slots[index] = slot;
            if (post.card !== card) card.remove();
        });
    });

    const wide = window.matchMedia("(min-width: 1100px)");
    function placePosts() {
        posts.forEach(({card, slots}) => {
            const slot = slots[wide.matches ? 0 : 1];
            if (slot) slot.after(card);
            else parking.appendChild(card);
        });
    }
    placePosts();
    wide.addEventListener("change", placePosts);
})();

/* Mobile menu burger toggle */
(function () {
    const navigation = document.body;
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.setAttribute('aria-expanded', 'false');

    const mobile = window.matchMedia('(max-width: 767px)');
    const root = document.documentElement;
    let scrollPosition = 0;

    function closeMenu() {
        if (!navigation.classList.contains('gh-head-open')) return;

        navigation.classList.remove('gh-head-open');
        burger.setAttribute('aria-expanded', 'false');
        root.classList.remove('gh-navigation-open');
        root.style.removeProperty('--gh-navigation-scroll-top');
        window.scrollTo({top: scrollPosition, behavior: 'instant'});
    }

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('gh-head-open')) {
            if (!mobile.matches) return;

            scrollPosition = window.scrollY;
            root.style.setProperty('--gh-navigation-scroll-top', `${-scrollPosition}px`);
            root.classList.add('gh-navigation-open');
            navigation.classList.add('gh-head-open');
            burger.setAttribute('aria-expanded', 'true');
        } else {
            closeMenu();
        }
    });

    mobile.addEventListener('change', function () {
        if (!mobile.matches) closeMenu();
    });
})();

/* Moment card metadata from Ghost Code Injection Head */
(function () {
    function extractMetaContentFromHead(headString, metaName) {
        if (!headString) {
            return null;
        }

        const escapedName = metaName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const metaPattern = new RegExp(`<meta\\s+[^>]*name=["']${escapedName}["'][^>]*>`, "i");
        const tagMatch = headString.match(metaPattern);

        if (!tagMatch) {
            return null;
        }

        const contentMatch = tagMatch[0].match(/\bcontent=["']([^"']+)["']/i);

        if (!contentMatch) {
            return null;
        }

        const textarea = document.createElement("textarea");
        textarea.innerHTML = contentMatch[1];

        return textarea.value;
    }

    function initMomentCard(card) {
        const head = card.getAttribute("data-codeinjection-head");
        const momentUrl = extractMetaContentFromHead(head, "alx-fave-url");
        const rating = parseFloat(extractMetaContentFromHead(head, "alx-rating"));
        const link = card.querySelector(".alx-moment-card-link");
        const ratingElement = card.querySelector(".alx-moment-card-rating");

        if (link) {
            if (!momentUrl) {
                link.removeAttribute("href");
                link.removeAttribute("target");
                link.removeAttribute("rel");
                card.classList.add("alx-moment-card-no-link");
            } else {
                link.setAttribute("href", momentUrl);
                link.setAttribute("target", "_blank");
                link.setAttribute("rel", "noopener");
                card.classList.remove("alx-moment-card-no-link");
            }
        }

        if (ratingElement && Number.isFinite(rating)) {
            const normalizedRating = Math.max(0, Math.min(5, Math.round(rating * 2) / 2));
            ratingElement.style.setProperty("--alx-rating-percent", `${normalizedRating * 20}%`);
            ratingElement.setAttribute("aria-label", `${normalizedRating} van 5 sterren`);
            ratingElement.hidden = false;
        } else if (ratingElement) {
            ratingElement.hidden = true;
        }
    }

    // Keep content links and media controls independent of the card destination.
    document.querySelectorAll(".alx-micro-card").forEach((card) => {
        const value = extractMetaContentFromHead(card.getAttribute("data-codeinjection-head"), "alx-threads-url");
        const permalink = card.querySelector(".alx-micro-card-permalink");
        const source = card.querySelector(".alx-micro-card-source");
        if (!permalink || !source) return;

        card.addEventListener("click", (event) => {
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            if (event.target.closest("a, button, input, textarea, select, label, video, audio, iframe, summary, [contenteditable], .kg-toggle-card")) return;
            if (window.getSelection().toString()) return;
            permalink.click();
        });

        if (!value) return;
        let url;
        try {
            url = new URL(value);
        } catch (error) {
            return;
        }
        if (url.protocol !== "https:" && url.protocol !== "http:") return;

        [permalink, source].forEach((link) => {
            link.href = url.href;
            link.target = "_blank";
            link.rel = "noopener noreferrer";
        });
        source.hidden = false;
    });

    document.querySelectorAll(".alx-moment-card").forEach(initMomentCard);

    document.querySelectorAll("[data-alx-favorite-groups]").forEach((feed) => {
        const groupedCards = new Map();

        feed.querySelectorAll(".alx-moment-card").forEach((card) => {
            const groupName = extractMetaContentFromHead(card.getAttribute("data-codeinjection-head"), "alx-favorite-group");

            if (!groupName) {
                return;
            }

            if (!groupedCards.has(groupName)) {
                groupedCards.set(groupName, []);
            }

            groupedCards.get(groupName).push(card);
        });

        if (!groupedCards.size) {
            return;
        }

        const parent = feed.parentElement;
        const referenceNode = feed.nextSibling;

        Array.from(groupedCards.entries()).sort(([firstName], [secondName]) => {
            return firstName.localeCompare(secondName, "nl", {sensitivity: "base"});
        }).forEach(([groupName, cards]) => {
            const section = document.createElement("section");
            section.className = "alx-favorite-subgroup";
            section.setAttribute("aria-label", groupName);

            const heading = document.createElement("h2");
            heading.className = "alx-favorite-subgroup-title";
            heading.textContent = groupName;

            const groupFeed = document.createElement("div");
            groupFeed.className = "alx-moments-archive-feed alx-favorites-subgroup-feed";

            cards.forEach((card) => {
                groupFeed.appendChild(card);
            });

            section.append(heading, groupFeed);
            parent.insertBefore(section, referenceNode);
        });

        if (!feed.querySelector(".alx-moment-card")) {
            feed.remove();
        }
    });
})();
